<template>
  <div class="fan-facet-area pb-100">
    <div class="container mw-1356">
      <div class="fan-facet-wrap">
        <div
          class="d-flex justify-content-lg-between justify-content-center gap-3 gap-md-4 gap-lg-0 align-items-center flex-wrap"
        >
          <div
            v-for="(fact, index) in facts"
            :key="index"
            class="fan-facet-single-item"
            data-aos="fade-up"
            data-aos-duration="1000"
            :data-aos-delay="(index + 1) * 100"
          >
            <h1>
              <span class="counter">{{ fact.value }}</span
              ><span>{{ fact.suffix }}</span>
            </h1>
            <p>{{ fact.label }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";

export default defineComponent({
  name: "FanFact",
  setup() {
    const facts = ref([
      { value: 25, suffix: "K+", label: "قناة عالمية" },
      { value: 500, suffix: "K+", label: "فيلم ومسلسل" },
      { value: 4, suffix: "K", label: "جودة مشاهدة" },
      { value: 99, suffix: "%", label: "استقرار الخدمة" },
      { value: 24, suffix: "/7", label: "دعم فني" },
    ]);

    return { facts };
  },
});
</script>